"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = exports.Head = exports.Cell = exports.Row = exports.Table = void 0;
var Table_1 = require("./Table");
Object.defineProperty(exports, "Table", { enumerable: true, get: function () { return __importDefault(Table_1).default; } });
var Row_1 = require("./Row");
Object.defineProperty(exports, "Row", { enumerable: true, get: function () { return __importDefault(Row_1).default; } });
var Cell_1 = require("./Cell");
Object.defineProperty(exports, "Cell", { enumerable: true, get: function () { return __importDefault(Cell_1).default; } });
var Head_1 = require("./Head");
Object.defineProperty(exports, "Head", { enumerable: true, get: function () { return __importDefault(Head_1).default; } });
var Body_1 = require("./Body");
Object.defineProperty(exports, "Body", { enumerable: true, get: function () { return __importDefault(Body_1).default; } });
